import {ReserveDepartmentAlertPopoverComponent} from './ReserveDepartmentAlertPopoverComponent';
import {BasePanelController} from '../../../../../../../BaseUI/BasePanelController';

/**
 * ReserveDoctorCreateCreatePanelController
 * 検査情報の作成画面のコントローラ
 */
export class ReserveDepartmentAlertPopoverController extends BasePanelController {
	// コンポーネントとコントローラーの結合用プロパティは、継承関係上の上書きする。
	// F12での参照が出来うようにする為と、クラス構造で、どのViewと紐づくか明示する為。
	public combineView: ReserveDepartmentAlertPopoverComponent;

}
